import { Field, Formik } from "formik";
import { get, isEmpty } from "lodash";
import Cancel from "../../../styles/cancel.png";
import React, { useEffect, useState, useRef, useContext } from "react";
import {
  Button,
  ButtonGroup,
  Form,
  Image,
  OverlayTrigger,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "react-bootstrap";
import { useRequest, useRouterParams, useDeepEffect } from "../../../abstracts";
import {
  DatePicker,
  FieldDropSide,
  ManageCensusLayout,
  MultiSelectDropdown,
  CsplTable as Table,
  Link,
  InProgressTile,
  DraftTile,
  ActiveLoansTile,
  CompletedLoansTile,
  LoaderWrapper,
  TabFilter,
  DraftCard,
} from "../../../components";
import {
  getCensusHistory,
  getRolloverInRequestDetailsByEmployeeId,
  deleteRolloverInRequestDetailsById,
  getPlanDetailsByEmployeeId,
  getWithdrawalByEmployeeId,
  getLoanByEmployeeId,
  deleteWithdrawalRequest,
  getTransferRequestDetailsByEmpId,
  deleteTransferRequest,
  getRebalanceRequestDetailsByEmpId,
  deleteRebalanceRequest,
  deleteLoanRequest,
} from "../../../services";
import {
  FLOW_TYPES,
  getPathWithParam,
  getUserRole,
  returnOnlyIfBoolean,
  ROUTES,
  usDateFormat,
  yesNoOptions,
  MANAGE_CENSUS_ROUTES,
  MANAGE_DISTRIBUTION_ROUTES,
  MANAGE_TRANSFER_ROUTES,
  getWithdrawalStatus,
  TRANSFER_STATUS,
  translateLoan,
  translateWithdrawal,
  translateRolloverIn,
} from "../../../utils";
import {
  manageCensusStore,
  setManageCensusLocalCache,
  setManageCensusToastInfo,
} from "../../../contexts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTimesCircle } from "@fortawesome/pro-light-svg-icons";
const drafts = [
  {
    requestType: "withdrawal",
    loanType: "Seperation from service",
    dateOfRequest: "22/4/2022",
    raisedBy: "Participant",
  },
  {
    requestType: "withdrawal",
    loanType: "General purpose loan",
    dateOfRequest: "1/7/2022",
    raisedBy: "Admin",
  },
  {
    requestType: "withdrawal",
    loanType: "General purpose loan",
    dateOfRequest: "1/7/2022",
    raisedBy: "Admin",
  },
  {
    requestType: "withdrawal",
    loanType: "General purpose loan",
    dateOfRequest: "1/7/2022",
    raisedBy: "Admin",
  },
];
// const activeLoans = [
//   {
//     loanType: "Personal Loan",
//     loanAmount: 10000,
//     loanPaidAmount: 7000,
//     loanStatus: "Active",
//     loanId: 421,
//     outStandingBalance: 8000,
//     dateOfRequest: "1/7/2022",
//     nextRepaymentDate: "2/8/2022",
//   },
// ];

const completedLoans = [
  {
    loanType: "Medical Loan",
    loanAmount: 10000,
    repaidAmount: 7000,
    loanStatus: "Closed",
    loanId: 421,
    dateOfRequest: "1/7/2022",
    lastPaidDate: "2/8/2022",
  },
];

const tabData = [
  {
    label: "All",
    active: true,
  },
  {
    label: "Current Loans",
    active: false,
  },
  {
    label: "Completed Loans",
    active: false,
  },
];

const ManageCensusTransactionsContainer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [withdrawalLoading, setWithdrawalLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [viewAll, setViewAll] = useState(false);
  const { censusId } = useRouterParams();
  const [loanType, setLoanType] = useState(1);
  const [res, setRes] = useState({});
  const { dispatch, state } = useContext(manageCensusStore);
  const [responseAvailable, setResponseAvailable] = useState(false);
  const [
    responseAvailableForWithdrawal,
    setResponseAvailableForWithdrawal,
  ] = useState(false);
  const [disableRequestOptions, setDisableRequestOptions] = useState(true);
  const [triggerRefresh, setTriggerRefresh] = useState(false);
  const [filterCondition, setFilterCondition] = useState("All");
  const [empTransactions, setEmpTransactions] = useState({
    submitted: [],
    inProgress: [],
    activeLoans: [],
    closedLoans: [],
  });
  const requestOptions = useRef([
    {
      label: "New Loan Request",
      path: ROUTES.LOAN_REQUEST,
      pathParam: [FLOW_TYPES.EDIT, censusId],
    },
    {
      label: "New Withdrawal Request",
      path: ROUTES.WITHDRAWAL_REQUEST,
      pathParam: [FLOW_TYPES.EDIT, censusId],
    },
    {
      label: "New RolloverIN Request",
      path: `${MANAGE_CENSUS_ROUTES.ROLLOVER_REQUEST}`,
      pathParam: [FLOW_TYPES.EDIT, censusId, 0, 2],
    },
    {
      label: "New Rebalance Request",
      path: MANAGE_TRANSFER_ROUTES.REBALANCE_REQUEST,
      pathParam: [FLOW_TYPES.EDIT, censusId],
    },
    {
      label: "New Transfer Request",
      path: MANAGE_TRANSFER_ROUTES.TRANSFER_REQUEST,
      pathParam: [FLOW_TYPES.EDIT, censusId],
    },
    {
      label: "Investment Election",
      path: "",
      pathParam: "",
    },
  ]);

  const [requestOptionsWithPlan, setRequestOptionsWithPlan] = useState(
    requestOptions.current
  );

  const onWithdrawalDeleteClick = (id) => {
    deleteWithdrawalRequest(id)
      .then((response) => {
        if (response) {
          setTriggerRefresh(!triggerRefresh);
          setResponseAvailable(false);
          setRes([]);
        } else {
          setErrorData({
            heading: "Error",
            reason: "Unable to delete the Withdrawal Request",
          });
          setShowError(true);
        }
      })
      .catch((error) => {
        setErrorData({
          heading: "Error",
          reason: "Unable to delete the Withdrawal Request",
        });
        setShowError(true);
      });
  };

  const onRebalanceDeleteClick = (id) => {
    deleteRebalanceRequest(id)
      .then((response) => {
        if (response) {
          setTriggerRefresh(!triggerRefresh);
          setResponseAvailable(false);
        } else {
          setErrorData({
            heading: "Error",
            reason: "Unable to delete the Rebalance Request",
          });
          setShowError(true);
        }
      })
      .catch((error) => {
        setErrorData({
          heading: "Error",
          reason: "Unable to delete the Rebalance Request",
        });
        setShowError(true);
      });
  };

  const onTransferDeleteClick = (id) => {
    deleteTransferRequest(id)
      .then((response) => {
        if (response) {
          setTriggerRefresh(!triggerRefresh);
          setResponseAvailable(false);
        } else {
          setErrorData({
            heading: "Error",
            reason: "Unable to delete the Transfer Request",
          });
          setShowError(true);
        }
      })
      .catch((error) => {
        setErrorData({
          heading: "Error",
          reason: "Unable to delete the Transfer Request",
        });
        setShowError(true);
      });
  };

  const onRollOverInDeleteClick = (id) => {
    setIsLoading(true);
    deleteRolloverInRequestDetailsById(id)
      .then((response) => {
        setIsLoading(false);
        if (response) {
          setTriggerRefresh(!triggerRefresh);
          setResponseAvailable(false);
          setRes({});
          dispatch(
            setManageCensusToastInfo({
              showToast: true,
              toastMessage: "Rollover request has been deleted",
            })
          );
        }
      })
      .catch((ex) => {
        setIsLoading(false);
      });
  };

  const onLoanDeleteClick = (id) => {
    deleteLoanRequest(id)
      .then((response) => {
        if (response) {
          setTriggerRefresh(!triggerRefresh);
          setResponseAvailable(false);
          setRes([]);
        } else {
          setErrorData({
            heading: "Error",
            reason: "Unable to delete the loan Request",
          });
          setShowError(true);
        }
      })
      .catch((error) => {
        setErrorData({
          heading: "Error",
          reason: "Unable to delete the Loan Request",
        });
        setShowError(true);
      });
  };

  const IsSubmittedStatus = (status) =>
    ![
      "InProgress",
      "Request In Progress",
      "Active",
      "Closed",
      "ClosedByRefinancing",
      "ClosedByReAmortization",
      "ClosedBySuspension",
      1,
    ].includes(status) || ["Approval In Progress"].includes(status);
  const IsInprogressStatus = (status) =>
    ["InProgress", "Request In Progress", 1].includes(status);
  const IsActiveStatus = (status) => status == "Active";
  const IsClosedStatus = (status) => status == "Closed";

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      getLoanByEmployeeId(censusId),
      getWithdrawalByEmployeeId(censusId),
      getRolloverInRequestDetailsByEmployeeId(censusId),
    ])
      .then((responses) => {
        setIsLoading(false);
        setResponseAvailable(true);
        let loanData = get(responses, "0.employeeLoan", []);
        let withdrawalData = get(responses, "1", []);
        let rolloverInData = get(
          responses,
          "2.employeeRolloverTransaction",
          []
        );

        let temp = [];

        if (!isEmpty(loanData)) {
          temp = temp.concat(
            translateLoan(loanData, censusId, onLoanDeleteClick)
          );
        }
        if (rolloverInData) {
          temp = temp.concat(
            rolloverInData.map((rolloverIn) =>
              translateRolloverIn(rolloverIn, censusId, onRollOverInDeleteClick)
            )
          );
        }
        if (!isEmpty(withdrawalData)) {
          temp = temp.concat(
            translateWithdrawal(
              withdrawalData,
              censusId,
              onWithdrawalDeleteClick
            )
          );
        }
        let filteredValues = {
          submitted: temp.filter((_) => IsSubmittedStatus(_.status)),
          inProgress: temp.filter((_) => IsInprogressStatus(_.status)),
          activeLoans: temp.filter((_) => IsActiveStatus(_.status)),
          closedLoans: temp.filter((_) => IsClosedStatus(_.status)),
        };
        setEmpTransactions(filteredValues);
      })
      .catch((error) => {
        setIsLoading(false);
      });

    // getTransferRequestDetailsByEmpId(censusId)
    //   .then((response) => {
    //     setIsLoading(false);
    //     if (!response.isSuccessfull) {
    //       //setResponseAvailable(false);
    //       return;
    //     }

    //     setRes({
    //       ...response.transferRequestDetails,
    //       amount: null,
    //       dateOfRequest: response.transferRequestDetails.dateOfRequest,
    //       status:
    //         TRANSFER_STATUS[response.transferRequestDetails.transferStatus],
    //       requestName: response.transferRequestDetails.requestType,
    //       sourceName: response.transferRequestDetails.sourceNames,
    //       raisedBy: response.transferRequestDetails.userName,
    //       isTransferRequest: true,
    //       onDeleteClick: () =>
    //         onTransferDeleteClick(response.transferRequestDetails.id),
    //       path:
    //         response.transferRequestDetails.transferStatus === 1
    //           ? MANAGE_TRANSFER_ROUTES.TRANSFER_REQUEST
    //           : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
    //       pathParam: [FLOW_TYPES.EDIT, censusId],
    //     });
    //     setResponseAvailable(true);
    //   })
    //   .catch((ex) => {
    //     setIsLoading(false);
    //   });

    // getRebalanceRequestDetailsByEmpId(censusId)
    //   .then((response) => {
    //     setIsLoading(false);
    //     if (!response.isSuccessfull) {
    //       //setResponseAvailable(false);
    //       return;
    //     }

    //     setRes({
    //       ...response.rebalanceRequestDetails,
    //       amount: null,
    //       dateOfRequest: response.rebalanceRequestDetails.dateOfRequest,
    //       status:
    //         TRANSFER_STATUS[response.rebalanceRequestDetails.rebalanceStatus],
    //       requestName: response.rebalanceRequestDetails.requestType,
    //       sourceName: response.rebalanceRequestDetails.sourceNames,
    //       raisedBy: response.rebalanceRequestDetails.userName,
    //       isTransferRequest: true,
    //       onDeleteClick: () =>
    //         onRebalanceDeleteClick(response.rebalanceRequestDetails.id),
    //       path:
    //         response.rebalanceRequestDetails.rebalanceStatus === 1
    //           ? MANAGE_TRANSFER_ROUTES.REBALANCE_REQUEST
    //           : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
    //       pathParam: [FLOW_TYPES.EDIT, censusId],
    //     });
    //     setResponseAvailable(true);
    //   })
    //   .catch((ex) => {
    //     setIsLoading(false);
    //   });

    // getRolloverInRequestDetailsByEmployeeId(censusId)
    //   .then((response) => {
    //     setIsLoading(false);
    //     if (!response.isSuccessfull) {
    //       //setResponseAvailable(false);
    //       return;
    //     }
    //     setResponseAvailable(true);
    //     setRes({
    //       ...response.employeeRolloverTransaction,
    //       amount: response.employeeRolloverTransaction.rolloverAmount,
    //       dateOfRequest: response.employeeRolloverTransaction.requestedDate,
    //       requestName: response.employeeRolloverTransaction.transactionType,
    //       onDeleteClick: () =>
    //         onRollOverInDeleteClick(response.employeeRolloverTransaction.id),
    //       path:
    //         response.employeeRolloverTransaction.status ===
    //         "Approval In Progress"
    //           ? MANAGE_CENSUS_ROUTES.ROLLOVER_SUMMARY
    //           : MANAGE_CENSUS_ROUTES.ROLLOVER_REQUEST,
    //       pathParam: [
    //         FLOW_TYPES.EDIT,
    //         censusId,
    //         response?.employeeRolloverTransaction?.id,
    //         2,
    //       ],
    //     });
    //   })
    //   .catch((ex) => {
    //     setIsLoading(false);
    //   });

    //setIsLoading(true);
    getPlanDetailsByEmployeeId(censusId)
      .then((response) => {
        if (response.isSuccessfull) {
          //setIsLoading(false);
          if (response.plan.length === 0) {
            setRequestOptionsWithPlan(
              requestOptions.current.filter(
                (_) => _.label != "New RolloverIN Request"
              )
            );
            return;
          }
          dispatch(
            setManageCensusLocalCache({
              model: "rollOverPlanDetails",
              data: response.plan,
            })
          );
        } else {
          // setIsLoading(false);
        }
      })
      .catch(() => {
        // setIsLoading(false);
      });
  }, [triggerRefresh]);

  useEffect(() => {
    if (
      !isEmpty(empTransactions?.inProgress) ||
      !isEmpty(empTransactions?.submitted)
    )
      setDisableRequestOptions(true);
    else setDisableRequestOptions(false);
  }, [res]);

  const onTabSwitch = (val) => {
    switch (val) {
      case "All":
        setFilterCondition("All");
        break;
      case "Current Loans":
        setFilterCondition("Active");
        break;
      case "Completed Loans":
        setFilterCondition("Closed");
        break;
    }
  };

  return (
    <LoaderWrapper isLoading={isEmpty(res) && (isLoading || withdrawalLoading)}>
      <ManageCensusLayout
        pageFlow={FLOW_TYPES.EDIT}
        censusId={censusId}
        requestOptions={requestOptionsWithPlan}
        disableRequestOptions={disableRequestOptions}
        transactionStatus={res?.status}
        transaction={res?.transaction}
      >
        <div className="w-100">
          {responseAvailable ? (
            <>
              <div className="mb-3">
                {!isEmpty(empTransactions?.submitted) && (
                  <div className="ft-14 fw-500 mb-2">Submitted Request</div>
                )}
                {empTransactions?.submitted?.map((data, index) => (
                  <InProgressTile
                    requestName={data.requestName}
                    amount={data.amount}
                    status={data.status}
                    type={data.type}
                    dateOfRequest={data.dateOfRequest}
                    raisedBy={data.raisedBy}
                    res={data}
                    censusId={censusId}
                    onDeleteClick={data.onDeleteClick}
                  />
                ))}
              </div>
              <div className="mb-3">
                {!isEmpty(empTransactions?.inProgress) && (
                  <div className="ft-14 fw-500 mb-2">Drafts Request</div>
                )}
                {empTransactions?.inProgress?.map((data, index) => (
                  <InProgressTile
                    requestName={data.requestName}
                    amount={data.amount}
                    status={data.status}
                    type={data.type}
                    dateOfRequest={data.dateOfRequest}
                    raisedBy={data.raisedBy}
                    res={data}
                    censusId={censusId}
                    onDeleteClick={data.onDeleteClick}
                  />
                ))}
              </div>
            </>
          ) : null}

          {(!isEmpty(empTransactions?.activeLoans) ||
            !isEmpty(empTransactions?.closedLoans)) && (
            <div>
              <div className="ft-14 fw-500 mb-2">Loan Details</div>
              <TabFilter
                isTransaction={true}
                tabData={tabData}
                onTabSwitch={onTabSwitch}
              />
              {["All", "Active"].includes(filterCondition) && (
                <>
                  {empTransactions?.activeLoans?.map((data, index) => (
                    <ActiveLoansTile
                      status={data.status}
                      loanId={data.loanId}
                      amount={data.amount}
                      repaidAmount={data.repaidAmount ?? 0}
                      type={data.type}
                      loanIdentifier={data.loanIdentifier}
                      censusId={censusId}
                      dateOfRequest={data.dateOfRequest}
                      outstandingBalance={data.outstandingBalance}
                      nextRepaymentDate={data.nextRepaymentDate}
                    />
                  ))}
                </>
              )}
              {["All", "Closed"].includes(filterCondition) && (
                <>
                  {empTransactions?.closedLoans?.map((data) => (
                    <CompletedLoansTile
                      status={data.status}
                      loanId={data.loanId}
                      amount={data.amount}
                      loanIdentifier={data.loanIdentifier}
                      repaidAmount={data.repaidAmount ?? 0}
                      type={data.type}
                      censusId={censusId}
                      dateOfRequest={data.dateOfRequest}
                      lastPaidDate={data.lastPaidDate}
                    />
                  ))}
                </>
              )}
            </div>
          )}
        </div>
        {showError && (
          <div
            className={`error-banner justify-content-between d-flex align-items-center ${
              (showError && "enable") || ""
            }`}
          >
            <div>
              <Image src={Cancel} width="30px" />
            </div>
            <div>
              <div className="error-heading">{errorData?.heading}</div>
              <div className="error-reason">{errorData?.reason}</div>
            </div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                color="#000"
                style={{ fontSize: "14px" }}
                onClick={() => setShowError(false)}
              />
            </div>
          </div>
        )}
      </ManageCensusLayout>
    </LoaderWrapper>
  );
};

export default ManageCensusTransactionsContainer;
